import axiosInstance from '../auth/axiosInstance';
import { resolveMenuDisplayLabel } from '../utils/rolePermissionsUtils';

/**
 * Fetches and maps the menu items from the server
 * Now includes `id` so that downstream `menuId` is populated correctly.
 *
 * @returns {Promise<Array<{id:number, name:string, path:string, icon:string, iconSelected:string}>>}
 */
export const getMenuList = async () => {
  try {
    console.log('Fetching menu items…');
    const { data: responseData } = await axiosInstance.get('/Menu/GetMenus');

    console.log('Raw menu API response:', responseData);

    const rawMenus = Array.isArray(responseData.data) ? responseData.data : [];

    const menus = rawMenus.map((item) => ({
      id: item.id,
      name:
        resolveMenuDisplayLabel(item.menuName, item.displayName) ||
        item.displayName ||
        item.menuName ||
        `Menu #${item.id}`,
      menuName: item.menuName,
      parentMenuId: item.parentMenuId ?? null,
      displayOrder: item.displayOrder ?? null,
      path: item.url,
      icon: item.iconUrl,
      iconSelected: item.iconUrl,
    }));

    return menus;
  } catch (error) {
    console.error('Error fetching menus:', error.message || error);
    throw error;
  }
};

/**
 * Fetches and returns the list of menu-permission mappings from the server
 * @returns {Promise<Array<{menuId:number,permissionId:number,isAllowed:0|1}>>}
 */
export const getMenuPermissions = async () => {
  try {
    console.log('Fetching menu permissions…');
    const { data: responseData } = await axiosInstance.get('/Menu/GetMenuPermissions');

    console.log('Raw permissions API response:', responseData);

    return Array.isArray(responseData.data) ? responseData.data : [];
  } catch (error) {
    console.error('Error fetching menu permissions:', error.message || error);
    throw error;
  }
};

/**
 * Add or update menu–permission mappings for a given role.
 * @deprecated Use `saveRoleMenuPermissions` from `rolePermissionsApi.ts` instead.
 */
export { saveRoleMenuPermissions as addOrUpdateUserMenuPermission } from './rolePermissionsApi';

/**
 * Fetches all role-based menu permission assignments.
 * @deprecated Use `fetchRolePermissionsList` from `rolePermissionsApi.ts` instead.
 */
export { fetchRolePermissionsList as getAllUsersRolesPermissions } from './rolePermissionsApi';

/**
 * Fetches menus and permissions for a specific role.
 * @param {number} roleId
 * @returns {Promise<{ data: Array<{ menuId, menuName, path, icon, permissions: Array<{ isAllowed:boolean }> }> }>}
 */
export const getUserMenuAndPermissions = async (roleId) => {
  try {
    const { data: payload } = await axiosInstance.get(
      `/Menu/GetUserMenuAndPermissions/${roleId}`
    );
    return payload || { data: [] };
  } catch (err) {
    console.error('getUserMenuAndPermissions:', err);
    throw err;
  }
};
